import React, { FunctionComponent as FC, ReactNode as RN, useState, useContext, useEffect } from 'react';
import { PietroskiFormItem } from './styled';
import { FormPropsContext, FormProps, FieldsContext/* , ValidationsContext */ } from '..';
import Input from '../input';

export interface ItemProps {
    children?: RN;
    inputLabel: string;
    inputType: string;
    width?: string;
    minHeight?: string;
    margin?: string;
    labelFrontSize?: string;
    labelAlign?: string;
}

const Item: FC<ItemProps> = (props: ItemProps) => {

    const { inputLabel = "text", inputType = "text" } = props;

    const useFormsProps = useContext<Partial<FormProps>>(FormPropsContext);
    const {darkMode} = useFormsProps;

    const [inputValues, setInputValues] = useState<Partial<string>>("");
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void  => {
        setInputValues(e.target.value);
    }

    const [useFieldGetter, useFieldSetter]: any = useContext<any>(FieldsContext);
    //const [errorList, useErrorSetter]: any = useContext(ValidationsContext);
    
    useEffect(() => {
        useFieldSetter({...useFieldGetter, [inputLabel]: {[inputLabel]: inputValues, inputType: inputType}});
    }, [inputValues]);

    return (
        <PietroskiFormItem>
          {inputLabel && <span>{inputLabel}:&nbsp;</span>}
          <Input {...props}
                 type={inputType ? `${inputType}` : "text"}
                 onChange={handleChange}
                 value={inputValues}
                 darkMode={darkMode}
          />
        </PietroskiFormItem>
    )
}

export default Item;